'use es6';

import { Record, Set as ImmutableSet } from 'immutable';
const AdEditReducerRecord = Record({
  name: null,
  schedule: null,
  budget: null,
  changes: ImmutableSet([])
});
export default (() => {
  return AdEditReducerRecord({});
});